// extracted by mini-css-extract-plugin
module.exports = {"container":"adaptive_container__soj1Y","containerPadded":"adaptive_containerPadded__mSXRn adaptive_container__soj1Y","section":"adaptive_section__SxbaA"};